<template>
  <b-container>
    <b-row class="ja-decoration">
    </b-row>

    <b-row>
      <b-col cols="12">

        <b-col cols="12" class="mt-1 title">{{ $t("verify_email_title_one") }} <br> {{ $t("verify_email_title_two") }}</b-col>

        <b-col cols="12" class="mt-3">
          <p class="text pb-3">
            {{ $t("verify_email_paragraph_one") }}
          </p>
          <p class="text description">
            {{ $t("verify_email_paragraph_two") }}
          </p>
        </b-col>
        <b-col cols="12" class="mt-2  button-content ">
          <b-button block variant="primary" :to="{ name: 'Login' }">
            {{ $t("verify_email_button_text") }}
          </b-button>
        </b-col>
      </b-col>
    </b-row>
    <legal-message />
  </b-container>
</template>

<script>
  import LegalMessage from "../Components/LegalMessage"

  export default {
    name: 'verifyEmail',
    components: {LegalMessage}
  }
</script>

<style scoped lang="stylus">
  @import "../Styles/security_styles.styl"

  .description
    padding-bottom 40px
</style>
